import React from 'react';
// import AddTodo from './component/AddTodo';\
import Todo from './component/Todo';
import './index.css'
import { motion } from 'framer-motion';
function App() {
  return (
    <div style={{backgroundColor:"black",height:"100vh",color:"white"}}>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <motion.h4
          style={{ fontSize: "20px" }}
          whileHover={{ scale: 1.1, rotate: [0, 2, -2, 2, -2, 2, -2, 0], transition: { repeat: Infinity, duration: 1 } }}
        >
          Mastering Momentum: The Redux Todo App for Enhanced Productivity
        </motion.h4>
      </div>
      {/* <AddTodo/> */}
      <div>
        <Todo />
      </div>


    </div>
  );
}

export default App;
